import React, {Component} from 'react';
 import {DropdownButton,  MenuItem} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
  import config from  '../../../config';
import {prepareSelectOptionsList,actionsFormatter,customFormatter,linkFormatter,  imagesFormatter, getFieldByPathFormatter} from 'util/Utils';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';
import { ADD_SELECTED_GBG_PRODUCTS,
    REMOVE_SELECTED_GBG_PRODUCTS,
} from "actions/actionTypes";




class AdminGBGProductListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);

        this.state = {

            perPage: config.table.numberPerPage,

        };

    }




    editRecord(row){
        this.props.editRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }

    formatCategories(cell, row, extra){

        return <div >{_.map(_.get(row,  ['Categories'], []), function (item, index) {
            var foundCategory = _.find(this.props.allCategories, function (category) {
                return category.TagName ==item.Category
            })
            if (foundCategory){
                foundCategory = foundCategory.CategoryName
            } else{
                foundCategory = 'Category not found'
            }
            var foundSubCategory = ''
            if (item.Subcategory) {
                foundSubCategory = _.find(this.props.allCategories, function (category) {
                    return category.TagName == item.Subcategory
                })
                if (foundSubCategory){
                    foundSubCategory = foundSubCategory.CategoryName
                } else{
                    foundSubCategory = 'Subcategory not found'
                }

            } else{
                foundSubCategory = ''
            }
             var styles ={marginTop:5}
            if (_.get(row,  ['Categories'], []).length !== index+1){
                styles.paddingBottom = 5;
                styles.borderBottom = '1px solid gray';
            }
                 return <div style={styles} key={index}>
                    <div className="green" >{foundCategory}</div>
                    <div  style={{color:'orange'}}>{foundSubCategory}</div>
                </div>

        }.bind(this) )}</div>
    }
    formatTags(cell, row, extra){

        return <div >{_.map(_.get(row,  [extra.field], []), function (item, index) {

            return <div style={{ }} key={index}>
                <div className="green" >{item}</div>
             </div>

        }.bind(this) )}</div>
    }
    formatGBGProductTags(cell, row, extra){

        return <div >{_.map(_.get(row,  [extra.field], []), function (tag, index) {
            var foundGBGProductTag = _.find(this.props.allGBGProductTags, item=>{
                return  item.value == tag
            })

            return <div style={{ }} key={index}>
                <div className={index %2 ==0 ? 'green':'orange'} >{foundGBGProductTag ? foundGBGProductTag.label: tag}</div>
            </div>

        }.bind(this) )}</div>
    }
    formatAgeGroups(cell, row, extra){
        return <div >{_.map(_.get(row,  ['AgeGroups'], []), function (item, index) {
            return <div key={index}>{item}</div>
        })}</div>
     }
    onRowSelect(row, isSelected, e) {
        var actionName =   isSelected ? ADD_SELECTED_GBG_PRODUCTS : REMOVE_SELECTED_GBG_PRODUCTS;
        this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
         var actionName =   isSelected ? ADD_SELECTED_GBG_PRODUCTS : REMOVE_SELECTED_GBG_PRODUCTS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
        if (!_.isUndefined(this.refs.table)) {
            var rowIDs = _.map(this.refs.table.state.data, function (row, key) {
                return row._id;
            });
        }
        var { type, checked, disabled, onChange, rowIndex } = props;

        if (!_.isUndefined(rowIDs) && rowIndex !== 'Header' ){
            checked = _.includes( _.map(this.props.adminGBGProducts.selectedProducts, '_id'), rowIDs[rowIndex])
        }

        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {

            return (
                <div className='checkbox-personalized'>
                    <CustomTableHeaderCheckbox { ...props }/>
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        } else {
            return (
                <div className='checkbox-personalized'>
                    <input
                        type={ type }
                        name={ 'checkbox' + rowIndex }
                        id={ 'checkbox' + rowIndex }
                        checked={ checked }
                        disabled={ disabled }
                        onChange={ e=> onChange(e, rowIndex) }
                    />
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        }
    }
    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)

        }

         return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.adminGBGProducts.data} ref='table'
                                 remote={ true }
                                selectRow={selectRowProp }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                 } }

                >
                    <TableHeaderColumn width="160px" dataField='GBGNote' dataAlign="center"dataSort={true}>Note</TableHeaderColumn>

                    <TableHeaderColumn width="50px" dataField='Brand' dataAlign="center"dataSort={true}>Brand</TableHeaderColumn>
                    <TableHeaderColumn width="90px" dataField='Model' dataAlign="center"dataSort={true}>Model</TableHeaderColumn>

                    <TableHeaderColumn width="70px" dataFormat={this.formatCategories.bind(this)} dataField='Categories' dataAlign="center"
                                       dataSort={true}>Categories</TableHeaderColumn>

                    <TableHeaderColumn width="70px" formatExtraData={ {'field': 'CategoryTags' } } dataFormat={this.formatTags.bind(this)} dataField='CategoryTags' dataAlign="center"
                                       dataSort={true}>Category Tags</TableHeaderColumn>
                    <TableHeaderColumn width="70px" formatExtraData={ {'field': 'GBGProductTags' } } dataFormat={this.formatGBGProductTags.bind(this)} dataField='GBGProductTags' dataAlign="center"
                                       dataSort={true}>Tags</TableHeaderColumn>
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                     <TableHeaderColumn width="70px" formatExtraData={ {'field': 'AgeGroups' } } dataFormat={this.formatAgeGroups.bind(this)} dataField='AgeGroups' dataAlign="center" >Age Groups</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField='CustomNote' dataAlign="center"dataSort={true}>Custom Note</TableHeaderColumn>
                    <TableHeaderColumn width="65px"
                                       columnClassName={  'table-cell-with-image' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return imagesFormatter.call(this,  row,  rowIndex,{
                                               displayMultipleImages:true,
                                               imagePath:   ['GBGProductImages'],
                                               total:this.props.total,
                                               perPage:this.state.perPage,
                                               currentPage:this.props.currentPage,
                                           } )
                                       }}
                                       dataField="GBGProductImages"
                                       dataAlign="center"
                                       dataSort={true}>
                        Images
                    </TableHeaderColumn>

                    <TableHeaderColumn width="70px"
                                       dataFormat={(cell, row, extra)=>{
                                           if (_.get(row, extra.labelPath, 0) >0) {
                                               return linkFormatter(cell, row, extra)
                                           } else {
                                               return  ''
                                           }

                                       } }
                                       formatExtraData={ {
                                           labelPath: ['QualityChecksNumber'],
                                           path: 'getObject',
                                           formatPathValue:(row)=>{
                                                return     'Brand='+_.get(row, 'Brand')+'&Model='+_.get(row, 'Model')
                                           },
                                           placeholder: '[queryParams]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/quality-checks?[queryParams]',
                                       }  }

                                       dataField='QualityChecksNumber' dataAlign="center"
                                       dataSort={true}>Quality Checks</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataAlign="center"  columnClassName={'actions-column'}
                                       formatExtraData={ {   menuItemsMap: [
                                           {onClick: 'editRecord', label: 'Edit'},
                                           {onClick: 'showRemoveDialog', label: 'Delete'},
                                       ]}}        dataFormat={ actionsFormatter.bind(this)  }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminGBGProductListTable;
